import Model from './Model';

export default class PartnerPayment extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'partner-payment';
  }
}
